// import images
import ProjectBimini from "../../assets/png/project-bimini.webp";
import ProjectCfa from "../../assets/png/project-cfa.webp";
import ProjectGaby from "../../assets/png/project-gaby.webp";
import ProjectMadoc from "../../assets/png/project-madoc.webp";
import ScrollAnimation from "./animations/ScrollAnimation";

const ProjectsHome = () => {
  return (
    <section className="mt-[90px] max-w-[1500px] mx-auto" id="realisations">
      {/* div titles */}
      <ScrollAnimation>
        <div className="ml-4 space-y-3 text-bluetextcoming mb-11 lg:ml-20">
          <h2 className="text-xl font-semibold md:text-2xl md:text-center lg:text-left">
            Dernières réalisations
          </h2>
          <h2 className="font-extrabold md:text-center lg:text-left">
            Des projets qui nous rapprochent
          </h2>
        </div>
      </ScrollAnimation>
      {/* div main */}

      <div className="flex-wrap mx-3 lg:mx-20 ">
        <ScrollAnimation>
          <div className="flex flex-col lg:flex-row">
            {/* div App mobile */}
            <div className="max-w-[579px] md:mx-auto  lg:mt-12 lg:mr-20 ">
              <img
                height={468}
                width={589.17}
                src={ProjectGaby}
                alt="images project gaby"
              />
              <button className="bg-gaby text-white text-sm py-3 px-5 rounded-[64px] font-semibold mt-6 mb-3">
                App mobile
              </button>
              <h3 className="max-w-[589px]">
                Le quotidien des techniciens du bâtiment réinventé
              </h3>
              <p className="mt-3 text-base font-medium text-corps">
                GABY by Sacarabany SARL
              </p>
            </div>
            {/* div App mobile */}

            <div className="mt-12 md:mx-auto  max-w-[589px]">
              <img
                src={ProjectMadoc}
                height={468}
                width={589.17}
                alt="images project madoc"
              />
              <button className="bg-madocsante text-white text-sm py-3 px-5 rounded-[64px] font-semibold mt-6 mb-3">
                Web App
              </button>
              <h3 className="max-w-[589px]">
                L’expérience de la télémédecine par objets connectés{" "}
              </h3>
              <p className="mt-3 text-base font-medium text-corps">
                Madoc Santé
              </p>
            </div>
          </div>
        </ScrollAnimation>
        <ScrollAnimation>
          <div className="flex flex-col lg:flex-row">
            {/* div App mobile */}
            <div className="mt-12 max-w-[589px] md:mx-auto lg:mr-20">
              <img
                src={ProjectCfa}
                height={468}
                width={589.17}
                alt="images project gaby"
              />
              <button className="bg-cfasante text-white text-sm py-3 px-5 rounded-[64px] font-semibold mt-6 mb-3">
                Site vitrine
              </button>
              <h3 className="max-w-[579px]">
                Les métiers de la santé par la voie de l’apprentissage
              </h3>
              <p className="mt-3 text-base font-medium text-corps">
                CFA Santé Martinique
              </p>
            </div>
            {/* div App mobile */}
            <div className="mt-12 max-w-[589px] md:mx-auto ">
              <img
                src={ProjectBimini}
                height={468}
                width={589.17}
                alt="images project gaby"
              />
              <button className="bg-bimini text-white text-sm py-3 px-5 rounded-[64px] font-semibold mt-6 mb-3">
                Web App
              </button>
              <h3>
                Les modulaires pour une expérience de construction plus flexible
              </h3>
              <p className="mt-3 text-base font-medium text-corps">
                Bimini Martinique
              </p>
            </div>
          </div>
        </ScrollAnimation>
      </div>
    </section>
  );
};

export default ProjectsHome;
